// extracted by mini-css-extract-plugin
export default {"button":"ConfirmationModal_button__b8ly-","modal":"ConfirmationModal_modal__8Zt8Z"};